'use client'

import { useModel } from '../hooks/useModel'
import { useNodeMaterials } from '../hooks/useNodeMaterials'

export function Starbucks(props) {
  const { nodes, materials } = useModel('/models/starbucks_mat.glb')
  const { getMat } = useNodeMaterials(materials)

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.uploads_files_2178712_Coffee_Shop_of_Kanayama.geometry}
        material={getMat(nodes.uploads_files_2178712_Coffee_Shop_of_Kanayama)}
        castShadow
        receiveShadow
      />
    </group>
  )
}

